// ==============================
// SYSTEM TOKEN REGISTRY
// ==============================
export const systemTokenRegistry = {
    "transformer/":  (account) => account?.trans?.token,
    "ahu_ms/":       (account) => account?.hvc?.ahu?.token,
    "th_ms/":        (account) => account?.temp?.temp?.token,
    "aqi/":          (account) => account?.temp?.indoor_aqi?.token ?? account?.temp?.outdoor_aqi?.token,
    "vibration/":    (account) => account?.vib?.vib?.token,
    "bms/":          (account) => account?.bms?.token,
    "pump_ms/":      (account) => account?.pump?.token,
    "busbar_temp/":  (account) => account?.temp?.bus_bar?.token,
    "ems/":  (account) => account.ems.token
};

// ==============================
// TOKEN RESOLVER
// ==============================
export const getAuthTokenByUrl = (url, account) => {
    // 1. Basic validation
    if (!url || !account) return account?.token;

    // 2. Search registry
    for (const key in systemTokenRegistry) {
        if (url.startsWith(key)) {
            try {
                const specificToken = systemTokenRegistry[key](account);

                // 3. If registry finds nothing (undefined/null), return fallback
                return specificToken ?? account?.token;
            } catch (error) {
                console.error(`Error resolving token for ${key}:`, error);
                return account?.token;
            }
        }
    }
    // 4. Final fallback for non-matching URLs
    return account?.token;
};